import styles from './Cards.module.scss';
import clx from 'classnames';
import { CreditCard, Landmark, Pencil } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const capitalize = (value) =>
  typeof value === 'string' && value ? value.charAt(0).toUpperCase() + value.slice(1) : value;

/**
 * Metodo di pagamento dell'abbonamento.
 * `paymentMethod` è l'oggetto Stripe espanso dal payment ms:
 *   { type: 'card', card: { brand, last4 } } | { type: 'sepa_debit', sepa_debit: { last4 } }
 */
export const Cards = ({ paymentMethod, handlePress, isMobile }) => {
  const { t } = useTranslation();
  const type = paymentMethod?.type;
  const isSepa = type === 'sepa_debit';
  const last4 = paymentMethod?.card?.last4 || paymentMethod?.sepa_debit?.last4;
  const brand = paymentMethod?.card?.brand;

  let label = t('settings.payments.paymentMethod.unknown');
  if (isSepa && last4) {
    label = t('settings.payments.paymentMethod.sepa', { last4 });
  } else if (type === 'card' && last4) {
    label = brand
      ? t('settings.payments.paymentMethod.card', { brand: capitalize(brand), last4 })
      : t('settings.payments.paymentMethod.cardGeneric', { last4 });
  }

  return (
    <div className={clx(styles.cards, { [styles.cards_mobile]: isMobile })}>
      <div className={styles.cards_list}>
        <div className={styles.cards_card}>
          <span
            className={clx(styles.cards_card_icon, { [styles.cards_card_icon_sepa]: isSepa })}
            aria-hidden="true"
          >
            {isSepa ? (
              <Landmark size={18} strokeWidth={2.2} />
            ) : (
              <CreditCard size={18} strokeWidth={2.2} />
            )}
          </span>
          <span className={styles.cards_card_number}>{label}</span>
        </div>
      </div>
      <button type="button" className={styles.cards_button} onClick={handlePress}>
        <Pencil size={16} strokeWidth={2.2} />
        {t('settings.payments.billingInfo.editPaymentMethod')}
      </button>
    </div>
  );
};
